import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pixels: [],
    loading: true,
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setPixels(state, pixels) {
      pixels.forEach((p, i) => {
        pixels[i].image = p.id;
      });
      state.pixels = pixels;
    },
  },
  actions: {
    fetchAllData({ dispatch, commit, state }) {
      commit("setLoading", true);
      console.log("Loading before", state.loading);
      let pixels = dispatch("fetchPixels");

      return Promise.all([pixels]).then(() => {
        // Both done
        commit("setLoading", false);
        console.log("Loading after", state.loading);
      });
    },
    fetchAllPixels({ state, commit }) {
      console.log("Fetch Pixels");
      return new Promise((resolve) => {
        const url = "/allPixelsWithChilds";

        axios
          .get(url)
          .then((res) => {
            console.log(res.data);
            commit("setPixels", res.data);
            resolve(state.pixels);
          })
          .catch((err) => console.log("error", err));
      });
    },
  },
  getters: {
    pixels: (state) => state.pixels,
  },
  modules: {},
});
